import React, { useState } from 'react';
import Select from 'react-select';
import Coaching from './WalkInEnrollment';
import Summer from './SummerEnrollmentForm';
import Rental from './Rental';
import Tournament from './Tournament';
import BulkBookingPayment from './BulkBookingPayment';
import BrokenRacket from './BrokenRacket';
import Others from './Others';
import Renewal from './Renewal';
import { hasPrivilege } from '../utils/hasPrivilege';
import { useUser } from '../context/UserContext';

const WalkInSales = () => {
  const { userData } = useUser();

  const privilegeMap = {
    coaching: ['CENTRE_MANAGEMENT', 'WALK_IN_COACHING_VIEW'],
    rental: ['CENTRE_MANAGEMENT', 'WALK_IN_RENTAL_VIEW'],
    // summer_camp: ['CENTRE_MANAGEMENT', 'WALK_IN_SUMMER_CAMP_VIEW'],
    tournament: ['CENTRE_MANAGEMENT', 'WALK_IN_TOURNAMENT_VIEW'],
    bulk_booking_payment: ['CENTRE_MANAGEMENT', 'WALK_IN_BULK_BOOKNIG_VIEW'],
    broken_rackets: ['CENTRE_MANAGEMENT', 'WALK_IN_BROKEN_RACKETS_VIEW'],
    others: ['CENTRE_MANAGEMENT', 'WALK_IN_OTHERS_MODIFY'],
    renewal: ['CENTRE_MANAGEMENT', 'RENEWAL_ENROLLMENTS'],
  };

  const allOptions = [
    { value: 'coaching', label: 'Coaching' },
    { value: 'rental', label: 'Rental' },
    // { value: 'summer_camp', label: 'Summer Camp' },
    { value: 'tournament', label: 'Tournament' },
    { value: 'bulk_booking_payment', label: 'Bulk Booking Payment' },
    { value: 'broken_rackets', label: 'Broken Equipments' },
    { value: 'others', label: 'Others' },
    { value: 'renewal', label: 'Renewal' },
  ];

  const filteredOptions = allOptions.filter(({ value }) => {
    const [module, privilege] = privilegeMap[value];
    return hasPrivilege(userData, module, privilege);
  });

  const [selectedOption, setSelectedOption] = useState(filteredOptions[0] || null);

  const handleChange = (option) => {
    setSelectedOption(option);
  };

  return (
    <div className="enrollment-container">
      <div className="floating-select-form" style={{ width: '100%' }}>
        <Select
          name="category"
          options={filteredOptions}
          value={selectedOption}
          onChange={handleChange}
          placeholder="Select Sales Type"
          className={`walkin-form-dropdown ${selectedOption ? 'has-value' : ''}`}
          classNamePrefix="walkin-select"
          styles={{
            control: (provided) => ({
              ...provided,
              padding: '5px',
            }),
            placeholder: (provided) => ({
              ...provided,
              color: 'black',
            }),
            menuPortal: (base) => ({ ...base, zIndex: 9999 }), 
          }}
          menuPortalTarget={document.body} 
        />
        {selectedOption && <label htmlFor="category">Sales Type</label>}
      </div>

      {selectedOption?.value === 'coaching' && <Coaching />}
      {selectedOption?.value === 'rental' && <Rental />}
      {/* {selectedOption?.value === 'summer_camp' && <Summer />} */}
      {selectedOption?.value === 'tournament' && <Tournament />}
      {selectedOption?.value === 'bulk_booking_payment' && <BulkBookingPayment />}
      {selectedOption?.value === 'broken_rackets' && <BrokenRacket />}
      {selectedOption?.value === 'others' && <Others />}
      {selectedOption?.value === 'renewal' && <Renewal />}
    </div>
  );
};

export default WalkInSales;
